import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import AuthService from '../../features/auth/auth.service'

import {Button, Modal } from 'react-bootstrap';

import { toast } from 'react-toastify'

import { tipoInversion, formatToTwoDecimals, formatearNumeroConComas } from '../../services/funcionesPublicas'


import Dialog from '../../services/Dialogs'



const ModalInversionFichaMesa = ( params : any ) => {

  const user = AuthService.getCurrentUser()

  const { show, handleClose, inversion } = params



 const [ f17, setF17 ] = useState<any>(inversion.monto_inversion)


     let filas = Array.from({ length: inversion.plazo_contrato }, (_, index) => index)

     let X : any = []
     let index = 0
     for(let reg of filas){
       // console.log(X[index-1].saldo_final)
         let r : any = {}
         if(index === 0) r = { saldo_inicial : inversion.monto_inversion, cargos :  (inversion.monto_inversion * ( inversion.tasa_incremento / 100 )), saldo_final : (inversion.monto_inversion + ( (inversion.monto_inversion * ( inversion.tasa_incremento / 100 )) ) + 0 )    }
          else{ 
            r = { saldo_inicial : X[index-1].saldo_final, cargos :  ((X[index-1].saldo_final * ( inversion.tasa_incremento / 100 ))), saldo_final : (X[index-1].saldo_final + ( (X[index-1].saldo_final * ( inversion.tasa_incremento / 100 )) ) + 0 )    }
            // console.log(X[index-1].saldo_final)
          }
         // return r

       // console.log([...X])
       // console.log(index)
       X.push(r)
       index++
     }
     // setTablaFinal(X)
 const [ tabla_final, setTablaFinal ] = useState<any>(X)





const dialog = new Dialog();

const [ envio_server, setSeEnvio ] = useState<boolean>(false)
const enviarFormulario = async (event:any) =>{

      await dialog.open({
        accept: 'Si',
        cancel: 'Espera',
        dialogClass: '',
        message: '¿Estás seguro de la información?',
        target: event.target,
        template: ``
      })
      let dialogo : any = await dialog.waitForUser()
      if(dialogo){
        try{

        setSeEnvio(true)
        let res_ = await RequestService.update( `inversion/enviar_mesa/${inversion.uuid_inversion}` , { })

        if(res_){
          toast.success('El Trámite pasa a creación de contrato')
          setTimeout(()=>{
            handleClose()
          },0)
        }
        else{
          toast.error('Problemas...')
        } 
        }
        catch(e:any){

          if (e.response?.status) {
            switch (e.response.status) {
              default:
                toast.error(e.response?.data)
            }
          }
          else{
            toast.error("Problemas con la busqueda")
          }
          setSeEnvio(false)

        }
        
      }
     
}





  return (
    <>
      <Modal show={show} size="lg" onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Ficha de Inversión</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            // JSON.stringify(inversion)
          }

            <h4>Información de Cliente</h4>
            <table className="table table-sm">
              <tbody>
                <tr>
                  <th className="v" style={{width:'40%'}}>Nombre</th>
                  <td>
                    <b>{inversion.nombres}</b>
                    <p className="nm"><small>{`${inversion.paterno} ${inversion.materno}`}</small></p>
                    </td>
                </tr>
                <tr>
                  <th className="v">Fecha de Nacimiento</th>
                  <td>{inversion.fecha_nacimiento}</td>
                </tr>
                <tr>
                  <th className="v">Sexo</th>
                  <td>{inversion.sexo==='H'?'HOMBRE':'MUJER'}</td>
                </tr>
                <tr>
                  <th className="v">CURP</th>
                  <td>{inversion.curp}</td>
                </tr>
                <tr>
                  <th className="v">RFC</th>
                  <td>{inversion.rfc||''}</td>
                </tr>
                <tr>
                  <th className="v">Seguro Social</th>
                  <td>{inversion.seguro_social}</td>
                </tr>
              </tbody>
            </table>

            <h4>Información de Contacto</h4>

            <table className="table table-sm">
              <tbody>
                <tr>
                  <th className="v" style={{width:'40%'}}>Dirección</th>
                  <td>{inversion.direccion}</td>
                </tr>
                <tr>
                  <th className="v">Colonia</th>
                  <td>{inversion.colonia}</td>
                </tr>
                <tr>
                  <th className="v">C.P.</th>
                  <td>{inversion.cp}</td>
                </tr>
              </tbody>
            </table>



 

                    <h4>Información de Inversión</h4>

                    <table className="table table-sm">
                      <tbody>
                        <tr>
                          <th className="v" style={{width:'40%'}}>Folio</th>
                          <td>{(inversion.folio)}</td>
                        </tr>
                        <tr>
                          <th className="v" style={{width:'40%'}}>Inversión</th>
                          <td>$ {formatToTwoDecimals(inversion.monto_inversion)}</td>
                        </tr>
                        <tr>
                          <th className="v">Tasa de Incremento</th>
                          <td>{inversion.tasa_incremento} %</td>
                        </tr>
                        <tr>
                          <th className="v">Plazo Contrato</th>
                          <td>{inversion.plazo_contrato} Meses</td>
                        </tr>
                        <tr>
                          <th className="v">Tipo de Retiro</th>
                          <td>{tipoInversion(inversion.tipo_retiro)}</td>
                        </tr>
                        <tr>
                          <th className="v">Forma de Pago</th>
                          <td>{inversion.forma_pago}</td>
                        </tr>



                                {
                                  inversion.tipo_retiro === 'mensual' && (
                                      <React.Fragment>

                                          <tr>
                                            <th className="v">Rendimiento Ganado</th>
                                            <td>
                                                  $ {
                                                    formatearNumeroConComas(
                                                      (Array.from({ length: inversion.plazo_contrato }, (_, index) => index)).map((p:any)=>{return inversion.monto_inversion*(inversion.tasa_incremento/100) }).reduce((acumulador, valor) => acumulador + valor, 0)
                                                      )
                                                  }
                                                  {' '}
                                                  <small>({
                                                    formatearNumeroConComas(((Array.from({ length: inversion.plazo_contrato }, (_, index) => index)).map((p:any)=>{return inversion.monto_inversion*(inversion.tasa_incremento/100) }).reduce((acumulador, valor) => acumulador + valor, 0) / inversion.monto_inversion ) * 100)
                                                  } %)</small>
                                            </td>
                                          </tr>
                                          <tr>
                                            <th className="v">Retención de ISR</th>
                                            <td>
                                                $ {
                                                  formatearNumeroConComas((Array.from({ length: inversion.plazo_contrato }, (_, index) => index)).map((p:any)=>{return inversion.monto_inversion*(inversion.tasa_incremento/100) }).reduce((acumulador, valor) => acumulador + valor, 0) * .20)
                                                }
                                            </td>
                                          </tr>
                                          <tr>
                                            <th className="v">Neto a Recibir</th>
                                            <td>
                                                  $ {
                                                      formatearNumeroConComas(
                                                        (Array.from({ length: inversion.plazo_contrato }, (_, index) => index)).map((p:any)=>{return inversion.monto_inversion*(inversion.tasa_incremento/100) }).reduce((acumulador, valor) => acumulador + valor, 0)
                                                        -
                                                        ((Array.from({ length: inversion.plazo_contrato }, (_, index) => index)).map((p:any)=>{return inversion.monto_inversion*(inversion.tasa_incremento/100) }).reduce((acumulador, valor) => acumulador + valor, 0) * .20)
                                                      )
                                                    }
                                            </td>
                                          </tr>



                                      </React.Fragment>
                                    )
                                }




                                {
                                  inversion.tipo_retiro === 'finalizando' && (
                                      <React.Fragment>

                                          <tr>
                                            <th className="v">Rendimiento Ganado</th>
                                            <td>
                                              $ {
                                                formatearNumeroConComas(tabla_final.reduce((acumulador:any, elemento:any) => acumulador + elemento.cargos, 0))
                                              }
                                              {' '}
                                              <small>({
                                                formatearNumeroConComas( (tabla_final.reduce((acumulador:any, elemento:any) => acumulador + elemento.cargos, 0)) / inversion.monto_inversion * 100)
                                              } %)</small>
                                            </td>
                                          </tr>
                                          <tr>
                                            <th className="v">Retención de ISR</th>
                                            <td>
                                                $ {
                                                  formatearNumeroConComas( (tabla_final.reduce((acumulador:any, elemento:any) => acumulador + elemento.cargos, 0)) * .20 )
                                                }
                                            </td>
                                          </tr>
                                          <tr>
                                            <th className="v">Neto a Recibir</th>
                                            <td>
                                                $ {
                                                formatearNumeroConComas(
                                                  tabla_final.reduce((acumulador:any, elemento:any) => acumulador + elemento.cargos, 0)
                                                  -
                                                  ((tabla_final.reduce((acumulador:any, elemento:any) => acumulador + elemento.cargos, 0)) * .20)
                                                  )
                                              }
                                            </td>
                                          </tr>



                                      </React.Fragment>
                                    )
                                }





                      </tbody>
                    </table>









              <h4>Desglose de Inversión</h4>


 
                                {
                                  inversion.tipo_retiro === 'mensual' && (
                                      <React.Fragment>



                                          <table className="table table-sm">
                                            <thead style={{fontSize:10}}>
                                              <tr>
                                                <th scope="col">No. De Meses</th>
                                                <th style={{width:'14%'}} scope="col">Saldo Inicial</th>
                                                <th style={{width:'14%'}} scope="col">Cargos</th>
                                                <th style={{width:'14%'}} scope="col">Abonos</th>
                                                <th style={{width:'14%'}} scope="col">Saldo Final</th>
                                                <th style={{width:'14%'}} scope="col">Retención de ISR</th>
                                                <th style={{width:'14%'}} scope="col">Neto a recibir mensual</th>
                                              </tr>
                                            </thead>
                                            <tbody style={{fontSize:12}}>

                                              <tr>
                                                <td>0</td>
                                                <td>$ {formatearNumeroConComas(inversion.monto_inversion)}</td>
                                                <td></td>
                                                <td></td>
                                                <td>$ {formatearNumeroConComas(f17)}</td>
                                                <td></td>
                                                <td></td>
                                              </tr>

                                            {
                                              Array.from({ length: inversion.plazo_contrato }, (_, index) => index).map((numero_mes:any,index:number)=>

                                                <React.Fragment key={ Math.random().toString(36).substr(2, 9) }>
                                                  
                                              <tr>
                                                <td>{index+1}</td>
                                                <td>$ {formatearNumeroConComas(inversion.monto_inversion)}</td> {/*saldo_inicial*/}
                                                <td>$ {formatearNumeroConComas(inversion.monto_inversion*(inversion.tasa_incremento/100))}</td>{/*Cargos*/}
                                                <td>$ {formatearNumeroConComas(inversion.monto_inversion*(inversion.tasa_incremento/100))}</td>{/*Abonos*/}
                                                <td>
                                                  $ { formatearNumeroConComas((inversion.monto_inversion) + (inversion.monto_inversion*(inversion.tasa_incremento/100)) - (inversion.monto_inversion*(inversion.tasa_incremento/100))) }
                                                </td>{/*Saldo Final*/}
                                                <td>$ {formatearNumeroConComas(((inversion.monto_inversion*(inversion.tasa_incremento/100)) * .2))}</td>{/*Retención de ISR*/}
                                                <td>$ {formatearNumeroConComas((inversion.monto_inversion*(inversion.tasa_incremento/100)) - ((inversion.monto_inversion*(inversion.tasa_incremento/100)) * .2))}</td>{/*Neto a recibir mensual*/}
                                              </tr>

                                                </React.Fragment>

                                                )
                                            }
                                            </tbody>
                                          </table>




                                      </React.Fragment>
                                    )
                                }



                                {
                                  inversion.tipo_retiro === 'finalizando' && (
                                      <React.Fragment>



 


                                          <table className="table table-sm">
                                            <thead style={{fontSize:10}}>
                                              <tr>
                                                <th scope="col">No. De Meses</th>
                                                <th style={{width:'14%'}} scope="col">Saldo Inicial</th>
                                                <th style={{width:'14%'}} scope="col">Cargos</th>
                                                <th style={{width:'14%'}} scope="col">Abonos</th>
                                                <th style={{width:'14%'}} scope="col">Saldo Final</th>
                                                <th style={{width:'14%'}} scope="col">Retención de ISR</th>
                                                <th style={{width:'14%'}} scope="col">Neto a recibir mensual</th>
                                              </tr>
                                            </thead>
                                            <tbody style={{fontSize:12}}>

                                              <tr>
                                                <td>0</td>
                                                <td>$ {formatearNumeroConComas(inversion.monto_inversion)}</td>
                                                <td></td>
                                                <td></td>
                                                <td>$ {formatearNumeroConComas(f17)}</td>
                                                <td></td>
                                                <td></td>
                                              </tr>

                                            {
                                              tabla_final.map((registro:any,index:number)=>

                                                <React.Fragment key={ Math.random().toString(36).substr(2, 9) }>
                                                  
                                              <tr>
                                                <td>{index+1}</td>
                                                <td>$ {formatearNumeroConComas(registro.saldo_inicial)}</td> {/*saldo_inicial*/}
                                                <td>$ {formatearNumeroConComas(registro.cargos)}</td>{/*Cargos*/}
                                                <td>-</td>{/*Abonos*/}
                                                <td>
                                                  $ { formatearNumeroConComas(registro.saldo_final) }
                                                </td>{/*Saldo Final*/}
                                                <td>-</td>
                                                <td>-</td>
                                              </tr>

                                                </React.Fragment>

                                                )
                                            }
                                            </tbody>
                                          </table>









                                      </React.Fragment>
                                    )
                                }

 
{
  // <Button variant="primary" size="lg" onClick={enviarFormulario} active> Enviar Creación de Contrato </Button>
}


 
            {
              // JSON.stringify(inversion)
            }













        </Modal.Body> 
      </Modal>
    </>
  );
}


export default ModalInversionFichaMesa;